import { FormGroup} from '@angular/forms';

export function ConfirmPasswordValidator(group: FormGroup) {
    const password = group.controls.password.value;
    const passwordConfirmation = group.controls.passwordConfirm.value;

    return password === passwordConfirmation ? null : { notSame: true };
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/validators/password-match.validator.ts